module.exports = __webpack_public_path__ + "static/L2_ux_1_3_dont-e47283c3175e979315b35e8953eb30ea.png";